import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const UserManual = () => import('@/views/UserManual')

// Users
const UserResetPass = () => import('@/views/users/UserResetPass')
const UserAdd = () => import('@/views/users/UserAdd')
const UserUpdate = () => import('@/views/users/UserUpdate')
const UsersList = () => import('@/views/users/UsersList')
const UserProfile = () => import('@/views/users/UserProfile')
const UserLogin = () => import('@/views/users/UserLogin')
const UserVerifyOTP = () => import('@/views/users/UserConfirmOTP')
const UserRegister = () => import('@/views/users/UserRegister')
const CategoryList = () => import('@/views/users/CategoryList')
const UserForgotPassword = () => import('@/views/users/UserForgotPassword')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const PageNoConfigUser = () => import('@/views/pages/PageNoConfigUser')

// Devices : Quản lý thiết bị
const DeviceList = () => import('@/views/devices/List')          /* Thiết bị */
const LiveStream = () => import('@/views/devices/LiveStream')          /* Thiết bị */
const PushRTMP = () => import('@/views/devices/MicrophonePushRTMP')          /* Thiết bị */
const Map = () => import('@/views/devices/MapDevice')          /* Thiết bị */

const UserActionLogList = () => import('@/views/administration/UserActionLogList') /* Nhật ký hành động */
const KeyAuthenticationList = () => import('@/views/administration/KeyAuthenticationList') /* Nhật ký hành động */
const ThreadList = () => import('@/views/administration/ThreadList')
const QueueList = () => import('@/views/administration/QueueList')
const PhoneSimManageList = () => import('@/views/administration/PhoneSimManageList')
const CacheList = () => import('@/views/administration/CacheList')
const UploadCheckSoundSpeaker = () => import('@/views/administration/UploadCheckSoundSpeaker')
const ConfigAuthenticationDevice = () => import('@/views/administration/ConfigAuthenticationDevice')
const VersionFwList = () => import('@/views/administration/VersionFwList')


/* ----- Quản lý nội dung ----- */
const FileList = () => import('@/views/file-management/FileList')              /* Danh sách tập tin */
const FileAdd = () => import('@/views/file-management/FileAdd')                 /* Biên tập bảng tin */
const FileMerge = () => import('@/views/file-management/MergeFile')                 /* Biên tập bảng tin */
const FileRecord = () => import('@/views/file-management/Record')                 /* Biên tập bảng tin */
const TextToSpeech = () => import('@/views/file-management/TextToSpeech')                 /* Biên tập bảng tin */
const PlayList = () => import('@/views/file-management/play-list/PlayList')                 /* Biên tập bảng tin */
const PlayListAdd = () => import('@/views/file-management/play-list/PlayListAdd')
const PlayListUpdate = () => import('@/views/file-management/play-list/PlayListUpdate')

/* ----- Quản lý lịch phát ----- */
const ScheduleList = () => import('@/views/schedule/List')
const ScheduleAdd = () => import('@/views/schedule/Add')
const ScheduleDetailList = () => import('@/views/schedule_detail/List')
const HistoryList = () => import('@/views/history/List')
const ListDuplicate = () => import('@/views/schedule/ListDuplicate')

const Broadcast = () => import('@/views/report/Broadcast')
const ReportDevice = () => import('@/views/report/ReportDevice')

//NotificationList: Thông báo
const NotificationList = () => import('@/views/notification/NotificationList')

const FileTypeList = () => import('@/views/administration/FileTypeList')     /* Lĩnh vực */
const ChannelDigitalList = () => import('@/views/administration/ChannelDigitalList')     /* Lĩnh vực */

const ConfigSyncHtttnList = () => import('@/views/administration/ConfigSyncHtttnList')
const ConfigSyncHtttnAdd = () => import('@/views/administration/ConfigSyncHtttnAdd')
const ConfigSyncHtttnUpdate = () => import('@/views/administration/ConfigSyncHtttnUpdate')

const LogSyncHtttnList = () => import('@/views/administration/LogSyncHtttnList')

const ConfigLocationList = () => import('@/views/administration/ConfigLocationList')
const ConfigSupplierList = () => import('@/views/administration/ConfigSupplierList')
const ConfigTTSList = () => import('@/views/administration/ConfigTextToSpeechList')
const ConfigTextToSpeechForm = () => import('@/views/administration/ConfigTextToSpeechForm')

Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  // base: process.env.NODE_ENV === 'development' ? '/' : '/',
  base: '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Trang chủ',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Thống kê',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/devices-management',
          redirect: '/devices-management/list.html',
          name: 'Quản lý thiết bị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list.html',
              name: 'Danh sách thiết bị',
              component: DeviceList
            },
            {
              path: 'map.html',
              name: 'Bản đồ',
              component: Map
            },
          ]
        },
        {
          path: '/radio-activities',
          redirect: '/radio-activities/livestream.html',
          name: 'Thao tác phát thanh',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'livestream.html',
              name: 'Phát thanh trực tiếp',
              // component: LiveStream
              component: PushRTMP
            },
            {
              path: 'push-rtmp.html',
              name: 'Phát thanh trực tiếp',
              component: PushRTMP
            },
            {
              path: 'managed-schedule.html',
              name: 'Phát thanh đặt lịch',
              component: ScheduleList
            },
            {
              path: 'schedule-add.html',
              name: 'Thêm lịch phát',
              component: ScheduleAdd
            },
            {
              path: ':id/managed-schedule-detail.html',
              name: 'Lịch phát chi tiết',
              component: ScheduleDetailList
            },
            {
              path: 'managed-duplicate.html',
              name: 'Xử lý lịch trùng',
              component: ListDuplicate
            },
            {
              path: 'managed-history.html',
              name: 'Danh sách nhật ký',
              component: HistoryList
            }
          ]
        },
        {
          path: '/media-management',
          redirect: '/media-management/managed-files.html',
          name: 'Quản lý nội dung',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-files.html',
              name: 'Nội dung ',
              component: FileList
            },
            {
              path: 'upload.html',
              name: 'Biên tập nội dung phát thanh',
              component: FileAdd,
            },
            {
              path: 'text-to-speech.html',
              name: 'Chuyển đổi văn bản qua giọng đọc',
              component: TextToSpeech,
            },
            {
              path: 'merge-files.html',
              name: 'Ghép tệp tin',
              component: FileMerge,
            },
            {
              path: 'record-files.html',
              name: 'Ghi âm tệp tin',
              component: FileRecord,
            },
            {
              path: 'play-list.html',
              name: 'Danh sách phát',
              component: PlayList,
            },
            {
              path: 'play-list/add.html',
              name: 'Thêm mới danh sách phát',
              component: PlayListAdd,
            },
            {
              path: 'play-list/:id/update.html',
              name: 'Thêm mới danh sách phát',
              component: PlayListUpdate,
            },
          ]
        },
        {
          path: '/report-management',
          redirect: '/report-management/device.html',
          name: 'Báo cáo thống kê',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'broadcast.html',
              name: 'Số lượng bản tin đã phát',
              component: Broadcast
            },
            {
              path: 'device.html',
              name: 'Tình trạng cụm loa',
              component: ReportDevice
            },
          ]
        },
        {
          path: '/administrator',
          redirect: '/administrator/user-activity-log.html',
          name: 'Quản trị',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'user-activity-log.html',
              name: 'Nhật ký hoạt động',
              component: UserActionLogList
            },
            {
              path: 'key-authentication.html',
              name: 'Quản lý Key kết nối',
              component: KeyAuthenticationList
            },
            {
              path: 'file-type.html',
              name: 'Quản lý lĩnh vực',
              component: FileTypeList
            },
            {
              path: 'channel-digital.html',
              name: 'Quản lý kênh số hóa',
              component: ChannelDigitalList
            },
            {
              path: 'thread.html',
              name: 'Quản lý tiến trình',
              component: ThreadList
            },
            {
              path: 'queue.html',
              name: 'Quản lý Queue',
              component: QueueList
            },
            {
              path: 'sim.html',
              name: 'Quản lý SIM',
              component: PhoneSimManageList
            },
            {
              path: 'cache.html',
              name: 'Quản lý Cache',
              component: CacheList
            },
            {
              path: 'sound-speaker.html',
              name: 'Kiểm tra trạng thái loa thiết bị',
              component: UploadCheckSoundSpeaker
            },
            {
              path: 'config-authentication.html',
              name: 'Quản lý thông tin xác thực TB',
              component: ConfigAuthenticationDevice
            },
            {
              path: 'version-fw.html',
              name: 'Quản lý Version TB',
              component: VersionFwList
            },
            {
              path: 'config-sync-htttn.html',
              name: 'Quản lý cấu hình đồng bộ HTTTN',
              component: ConfigSyncHtttnList
            },
            {
              path: 'config-sync-htttn-add.html',
              name: 'Thêm mới cấu hình đồng bộ HTTTN',
              component: ConfigSyncHtttnAdd
            },
            {
              path: ':id/config-sync-htttn-update.html',
              name: 'Cập nhật cấu hình đồng bộ HTTTN',
              component: ConfigSyncHtttnUpdate
            },
            {
              path: 'log-sync-htttn.html',
              name: 'Lịch sử request HTTTN',
              component: LogSyncHtttnList
            },
            {
              path: 'config-location.html',
              name: 'Cấu hình địa bàn',
              component: ConfigLocationList
            },
            {
              path: 'config-supplier.html',
              name: 'Cấu hình NCC',
              component: ConfigSupplierList
            },
            {
              path: 'config-text-to-speech.html',
              name: 'Cấu hình TTS',
              component: ConfigTTSList
            },
            {
              path: ':id/config-text-to-form.html',
              name: 'Cấu hình thông tin TTS',
              component: ConfigTextToSpeechForm
            },
          ]
        },
        {
          path: '/user-management',
          redirect: '/user-management/managed-users.html',
          name: 'Quản lý tài khoản',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-users.html',
              name: 'Danh sách tài khoản',
              component: UsersList
            },
            {
              path: 'new.html',
              name: 'Thêm mới tài khoản',
              component: UserAdd
            },
            {
              path: ':id/managed-user.html',
              name: 'Cập nhật tài khoản',
              component: UserUpdate
            },
            {
              path: 'my-profile.html',
              name: 'Thông tin tài khoản',
              component: UserProfile
            }
          ]
        },
        {
          path: '/notification-management',
          redirect: '/notification-management/managed-notification.html',
          name: 'Danh sách thông báo',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-notification.html',
              name: 'Danh sách thông báo',
              component: NotificationList
            }
          ]
        },
        {
          path: '/user-manual.html',
          name: 'Hướng dẫn sử dụng',
          component: UserManual,
          meta: {
            requiresAuth: true,
          }
        },
      ]
    },
    {
      path: '/login.html',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/forgot-password.html',
      name: 'UserForgotPassword',
      component: UserForgotPassword,
    },
    {
      path: '/authorize',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/verify.html',
      name: 'UserVerifyOTP',
      component: UserVerifyOTP,
    },
    {
      path: '/register.html',
      name: 'UserRegister',
      component: UserRegister,
    },
    {
      path: '/user',
      name: 'user',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'reset-password.html',
          name: 'UserResetPass',
          component: UserResetPass
        }
      ]
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        },
        {
          path: 'pending-config',
          name: 'pendingConfig',
          component: PageNoConfigUser
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },

  ]
})

export default router
